import { useState } from 'react';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { PriceInvisibilityRulesList } from './components/PriceInvisibilityRulesList';
import { PriceInvisibilityRulePopup } from './Popups/PriceInvisibilityRulePopup';
import { TotadminPermission } from 'data/__generated__';

export const PriceInvisibilityRules = () => {
    const [isCreatePopupOpen, setIsCreatePopupOpen] = useState<boolean>(false);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.priceInvisibilityRules} />
                </HeaderTitle>
                <TotemPrimaryButton
                    onClick={() => setIsCreatePopupOpen(true)}
                    requiredPermissions={[TotadminPermission.PriceInvisibilityRulesManage]}
                >
                    Créer une règle
                </TotemPrimaryButton>
            </Header>
            <PriceInvisibilityRulesList />
            <PriceInvisibilityRulePopup isOpen={isCreatePopupOpen} setIsOpen={setIsCreatePopupOpen} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
